<template>
  <el-form
    v-loading="loading"
    element-loading-text="拼命加载中"
    :model="ruleForm"
    :rules="editRules"
    ref="ruleForm"
    label-width="80px"
    class="demo-ruleForm"
    size="mini"
  >
    <div class="from-style">
      <div>
        <el-form-item label="名称:" style="width: 340px" prop="name">
          <el-input
            placeholder="请输入名称(不可超过10位字符)"
            type="text"
            maxlength="10"
            clearable
            v-model="ruleForm.name"
            style="width: 360px"
          ></el-input>
        </el-form-item>
        <div class="text-area">
          <el-form-item label="备注:" style="width: 340px" prop="remark">
            <el-input
              placeholder="请输入备注"
              clearable
              type="textarea"
              rows="9"
              resize="none"
              v-model="ruleForm.remark"
              style="width: 360px"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button
            :disabled="accessControl.rolemanagemodify == true"
            type="primary"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button @click="resetForm('ruleForm')">关闭</el-button>
        </el-form-item>
      </div>
      <div class="authority">
        <el-form-item label="操作权限:" prop="right">
          <el-scrollbar
            style="border: 1px solid #e6e6e6; width: 360px; height: 82vh"
            v-loading="treeLoading"
            element-loading-text="正在加载中!"
          >
            <el-tree
              :data="rightTree"
              ref="editTree"
              show-checkbox
              node-key="id"
              :props="defaultProps"
            >
            </el-tree>
          </el-scrollbar>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>
<script>
import { request } from '../dataApi/_request/index'
import Api from '../apis/api'
export default {
  props: {
    roleData: Array,
    formData: Object,
    baranchData: Array,
    treeHeight: Number,
    type: String,
    tabName: String,
    accountname: String,
    destinationId: Number,
    systemData: Array,
    rightData: Array,
    accessControl: Object
  },
  mounted() {
    this.gsdgsgagzdzx()
    let from = _.cloneDeep(this.formData)
    this.ruleForm = from
    this.handleTreeData()
  },
  data() {
    return {
      loading: false,
      ruleForm: [],
      editBaranch: [],
      editRole: [],
      role_name: '',
      rightTree: [],
      untreatedData: [],
      unsystemData: [],
      treeLoading: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      allCheckData: {},
      editRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    gsdgsgagzdzx() {
      let params = {
        method: 'post',
        url: Api.getOutLink,
        data: {
          destination_id: this.formData.destination_id
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }
      request(params).then((res) => {
        if (res.total != 0) {
          this.handleTreeData(res.data)
        }
      })
    },
    // 保存 用户信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          let currentRight = this.getCurrentRight()
          this.ruleForm.right = JSON.stringify(currentRight)
          this.ruleForm.destination_id = this.destinationId
          this.ruleForm.manager_id = this.destinationId

          if (this.type == 'add') {
            let params = {
              method: 'post',
              url: Api.addRole,
              data: { data: this.ruleForm },
              headers: {
                'Content-Type':
                  'application/x-www-form-urlencoded; charset=UTF-8'
              }
            }
            request(params)
              .then((res) => {
                if (res.errcode == 0) {
                  this.ruleForm.row_id = res.data.result
                  this.$emit('update', this.ruleForm, this.tabName, 'add')
                  this.$message({
                    message: '新增成功',
                    type: 'success'
                  })
                } else {
                  this.$message.error('新增失败')
                }
                this.loading = false
              })
              .catch((error) => {
                this.loading = false
              })
          } else {
            let right = this.handleCheck()
            this.ruleForm.right = JSON.stringify(right)

            let paramsto = {
              method: 'post',
              url: Api.modifyRole,
              data: { data: this.ruleForm },
              headers: {
                'Content-Type':
                  'application/x-www-form-urlencoded; charset=UTF-8'
              }
            }
            request(paramsto)
              .then((res) => {
                if (res.errcode == 0) {
                  this.$emit('update', this.ruleForm, this.tabName)
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  })
                  this.$nextTick(() => {
                    this.$message({
                      message: '如有需要账户需重新绑定角色以同步权限',
                      duration: 5000
                    })
                  })
                } else {
                  this.$message.error('修改失败')
                }
                this.loading = false
              })
              .catch((error) => {
                this.loading = false
              })
          }
        } else {
          return false
        }
      })
    },
    handleCheck() {
      let editRigh = this.allCheckData
      console.log(editRigh, '角色下的所有权限')
      // 页面中被勾选中的 系统数据
      let checkedList = this.$refs.editTree.getCheckedNodes(false, true)
      console.log(checkedList, '勾选中的值')
      let systemList = []
      // 系统名称
      checkedList.forEach((item) => {
        if (item.parent_id == '-1') {
          systemList.push(item.id)
        }
      })

      let currentRight = {}

      systemList.forEach((system) => {
        currentRight[system] = []
        checkedList.forEach((item) => {
          if (item.parent_id != '-1' && item.id.indexOf(system) >= 0) {
            currentRight[system].push(item.id.replace(system + '-', ''))
          }
        })
      })

      for (let key in currentRight) {
        // 查找是否有对应的 key
        // if (editRigh.hasOwnProperty(key)) {
        if (Object.prototype.hasOwnProperty.call(editRigh, key)) {
          console.log('key值相同')
          editRigh[key] = currentRight[key]
        } else {
          console.log('key值不相同')
          // 新增权限 拼接到 right 中
          editRigh = { ...editRigh, ...currentRight }
        }
      }
      return editRigh
    },
    //获取当前权限
    getCurrentRight() {
      //let checkedNodeList = this.$refs.editTree.getCheckedNodes(false, true);
      let checkedList = this.$refs.editTree.getCheckedNodes(false, true) //JSON.parse(JSON.stringify(checkedNodeList));
      let systemList = []
      checkedList.forEach((item) => {
        if (item.parent_id == '-1') {
          systemList.push(item.id)
        }
      })
      let currentRight = {}
      systemList.forEach((system) => {
        currentRight[system] = []
        checkedList.forEach((item) => {
          if (item.parent_id != '-1' && item.id.indexOf(system) >= 0) {
            currentRight[system].push(item.id.replace(system + '-', ''))
          }
        })
      })
      return currentRight
    },
    // 处理权限节点
    handleTreeData(ssss) {
      this.treeLoading = true
      let system = this.systemData
      let right = this.rightData
      let fatherData = this.findFatherTree(system)
      let sonData = this.findSonTree(right)
      ssss?.forEach((link) => {
        fatherData.forEach((ther) => {
          if (ther.row_id == link.system_id && link.out_link_name) {
            ther.label = link.out_link_name
          }
        })
      })
      fatherData.forEach((item) => {
        sonData.forEach((events) => {
          if (item.id === events.system) {
            if (!item['children']) {
              item['children'] = [events]
            } else {
              item['children'].push(events)
            }
          }
        })
      })
      this.treeLoading = false
      // 树结构
      this.rightTree = fatherData
      //设置树节点选中
      if (this.type == 'edit') {
        let trNode = {}
        try {
          trNode = JSON.parse(this.ruleForm.right)
        } catch (err) {
          console.log(err)
        }
        if (trNode != '{}') {
          this.allCheckData = trNode
          let checkedIdList = []
          for (let key in trNode) {
            let sysNode = trNode[key]
            checkedIdList.push(key)
            trNode[key].forEach((item) => {
              checkedIdList.push(key + '-' + item)
            })
          }
          this.$refs.editTree.setCheckedKeys(checkedIdList, true)
          //解决父选框选中时，也会导致子选项都会被选中的问题
          setTimeout(() => {
            // 获取树中所有选中的值
            let defaultCheckAll = this.$refs.editTree.getCheckedKeys()
            // 通过对比树所有选中的值（defaultCheckAll）和详情返回选中的值（checkedIdList）去取两个数组的差集
            let deleteArr = defaultCheckAll.filter(
              (item) => !checkedIdList.some((item_1) => item_1 === item)
            )
            // 遍历去掉不需要选中的值
            deleteArr.map((item) => {
              this.$refs.editTree.setChecked(item, false)
            })
          }, 200)
        }
      }
    },
    // 处理树子节点
    findSonTree(data) {
      let rightArray = []
      data.forEach((items) => {
        rightArray.push({
          id: items.system + '-' + items.right_value,
          label: items.remark,
          row_id: items.row_id,
          parent_id: items.parent_id,
          system: items.system,
          right_value: items.right_value,
          disabled: false
        })
      })
      const RightTree = arrayToTree(rightArray)
      function arrayToTree(items) {
        const result = [] // 存放结果集
        const itemMap = {} //
        for (const item of items) {
          const id = item.row_id
          const parent_id = item.parent_id
          if (!itemMap[id]) {
            itemMap[id] = {
              children: []
            }
          }
          itemMap[id] = {
            ...item,
            children: itemMap[id]['children']
            // children: [],
          }
          const treeItem = itemMap[id]
          if (parent_id === '0') {
            result.push(treeItem)
          } else {
            if (!itemMap[parent_id]) {
              itemMap[parent_id] = {
                children: []
              }
            }
            itemMap[parent_id].children.push(treeItem)
          }
        }
        return result
      }
      return RightTree
    },
    // 处理树父节点
    findFatherTree(parents) {
      let tree = []
      parents.forEach((item) => {
        let node = {
          id: item.identify,
          row_id: item.id,
          label: item.label,
          parent_id: '-1',
          disabled: false
        }
        tree.push(node)
      })
      return tree
    },
    resetForm(formName) {
      //this.$refs[formName].resetFields();
      this.$emit('update', '', this.tabName, 'close')
    }
  }
}
</script>
<style lang="scss" scoped>
.from-style {
  height: 100%;
  display: flex;
  margin-top: 14px;
  :deep(.el-input--mini) {
    width: 344px;
  }
  .authority {
    width: 40%;
    margin-left: 10%;
  }
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #06c1a8;
    border-color: #06c1a8;
  }

  :deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner) {
    background-color: #f2f6fc;
    border-color: #dcdfe6;
  }

  :deep(.text-area) {
    ::-webkit-scrollbar {
      width: 4px; /*滚动条宽度*/
      height: 8px; /*滚动条高度*/
    }
    .el-textarea__inner::-webkit-scrollbar-thumb {
      background-color: rgba(168, 168, 168, 0.4); /*滚动条默认显示的颜色*/
    }

    .el-textarea__inner::-webkit-scrollbar {
      width: 6px;
      height: 8px;
      background-color: white; /*滚动条背景色显示的颜色*/
    }
  }
}
</style>
